require('./virtualMachines.style.scss');

const virtualMachinesModule = angular.module('com.comtrade.azureCloud.backup.virtualMachines', []);

virtualMachinesModule.component('virtualMachines', require('./virtualMachines.component'));
virtualMachinesModule.component('credentialsDialog', require('./dialogs/credentialsDialog/credentialsDialog.component'));
virtualMachinesModule.component('recoverVm', require('./dialogs/recoverVm/recoverVm.component'));
virtualMachinesModule.component('recoverFile', require('./dialogs/recoverFile/recoverFile.component'));
virtualMachinesModule.component('vmsBackupActions', require('./vmsBackups/vmsBackupActions/vmsBackupActions.component'));
virtualMachinesModule.component('vmConfiguration', require('./dialogs/vmConfiguration/vmConfiguration.component'));
virtualMachinesModule.component('policiesDialog', require('./dialogs/policiesDialog/policiesDialog.component'));
virtualMachinesModule.component('multiVmConfiguration', require('./dialogs/multiVmConfiguration/multiVmConfiguration.component'));
virtualMachinesModule.component('addSnapshotScriptDialog', require('./dialogs/addSnapshotScriptDialog/addSnapshotScriptDialog.component'));


virtualMachinesModule.service('virtualMachinesPersistence', require('./virtualMachines.persistence.service'));
virtualMachinesModule.service('recoverFileService', require('./dialogs/recoverFile/recoverFile.service'));

module.exports = virtualMachinesModule;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/virtualMachines.module.js